import React from "react";
import Particle from "../../Particle";
import { Container, Row, Col } from "react-bootstrap";
import Zoom from "react-reveal/Zoom";
import { Fade } from "react-reveal";
import { FaCode } from "react-icons/fa";

// Projects data array
const projects = [
  {
    id: 1,
    title: "Bharat Store",
    description:
      "Bharat Store is an e-commerce web application offering a wide range of clothing options and all essential features expected in an online shopping platform.",
    technologies: "ReactJs, NodeJs, ExpressJs, MongoDb, TailwindCss",
    image: require("../../images/bharat_store.png"),
    link: "https://github.com/Prashant-Malviya/Bharat-Store",
  },
  {
    id: 2,
    title: "YouTube Web App",
    description:
      "The YouTube Web App is an advanced clone of the YouTube platform, featuring video listings, seamless playback, user profiles with uploaded videos, subscriber counts, and detailed engagement metrics like likes, comments, and views.",
    technologies: "ReactJs, TailwindCss, Rapid Api, Axios",
    image: require("../../images/youtube.png"),
    link: "https://youtube-app-by-prashant-malviya.netlify.app/",
  },
  {
    id: 3,
    title: "EduBharat",
    description:
      "EduBharat is a powerful e-learning platform connecting students and teachers. Students can access tutorials across categories, while teachers can upload and manage content with ease. Key features include category-based filtering, personalized recommendations, progress tracking, and intuitive dashboards, ensuring an efficient and engaging learning experience.",
    technologies: "ReactJs, TailwindCss, Rapid Api, Axios",
    image: require("../../images/edubharat.png"),
    link: "https://github.com/Prashant-Malviya/EduBharat",
  },
  {
    id: 4,
    title: "Restaurant-Table-Booking-Web-App",
    description:
      "This is a Booking System project designed to handle reservations for a specified date and time. The system allows users to view available time slots, make bookings, and see a summary of their reservation. It prevents double bookings and provides a seamless user experience.",
    technologies: "ReactJs, TailwindCss, NodeJs, ExpressJs, MongoDB",
    image: require("../../images/Reservation System.png"),
    link: "https://github.com/Prashant-Malviya/Restaurant-Table-Booking-Web-App",
  },

  {
    id: 5,
    title: "Task Management Web App",
    description:
      "This project is a simple Task Manager application built using React.js. The app allows users to manage tasks by adding, editing, deleting, and filtering tasks based on their status. The application features a responsive user interface to ensure usability across devices of different screen sizes.",
    technologies: "ReactJs, TailwindCss, Tabulator.js",
    image: require("../../images/Task Management Web App.png"),
    link: "https://github.com/Prashant-Malviya/Task-Management-Todo-App",
  },

  {
    id: 6,
    title: "Product Store",
    description:
      "Product Store is a comprehensive eCommerce web application offering a diverse range of product categories, ensuring a seamless and user-friendly shopping experience. With its modern, visually appealing UI design and meticulously styled components, the platform provides intuitive navigation and an engaging interface that caters to all your shopping needs",
    technologies: "ReactJs, TailwindCss, Tabulator.js",
    image: require("../../images/product_store.png"),
    link: "https://product-store-by-prashant.netlify.app/",
  },
];

export default function ProjectPage() {
  return (
    <section className="home-section">
      <Container fluid id="home">
        <Particle />
        <Container className="home-content">
          <div
            className="d-flex justify-content-center relative bottom-14"
            width="100%"
            style={{ backgroundColor: "#fbd9ad" }}
          >
            <Zoom left cascade>
              <h1 style={{ color: "rgb(134 61 176" }}>PROJECTS</h1>
            </Zoom>
          </div>
          <Container fluid className="certificate-section" id="about">
            <Container>
              <Row className=" g-4 flex-wrap">
                {projects.map((project) => (
                  <Col
                    key={project.id}
                    xs={12}
                    sm={6}
                    md={4}
                    className="d-flex justify-content-center"
                  >
                    <Fade bottom>
                      <div
                        className="singleProject"
                        style={{
                          backgroundColor: "rgb(142 70 186 / 31%)",
                          border: "1px solid",
                          padding: "1rem",
                          maxWidth: "300px",
                        }}
                      >
                        <div className="projectContent">
                          <h5 style={{ color: "#fbd9ad" }}>{project.title}</h5>
                          <img
                            src={project.image}
                            alt={project.title}
                            style={{ width: "100%", height: "auto" }}
                          />
                          <div className="project--showcaseBtn mt-2">
                            <a
                              href={project.link}
                              target="_blank"
                              rel="noreferrer"
                              className={"iconBtn"}
                              aria-labelledby={`code-${project.id}`}
                            >
                              <FaCode
                                id={`code-${project.id}`}
                                className={"icon"}
                                aria-label="Code"
                              />
                            </a>
                          </div>
                        </div>
                        <h6>
                          <p
                            className="project--desc"
                            style={{
                              background: "#fbd9ad",
                              color: "#b061df",
                              fontWeight: 600,
                            }}
                          >
                            {project.description}
                          </p>
                        </h6>
                        <div
                          className="project--lang"
                          style={{
                            background: "#fbd9ad",
                            color: "#b061df",
                            fontWeight: 600,
                          }}
                        >
                          {project.technologies}
                        </div>
                      </div>
                    </Fade>
                  </Col>
                ))}
              </Row>
            </Container>
          </Container>
        </Container>
      </Container>
    </section>
  );
}
